// extracted by mini-css-extract-plugin
module.exports = {"tabletUp":"840px"};